// extracted by mini-css-extract-plugin
export var errorIcon = "_lr-1";
export var nameLogo = "_lr-0";